import * as React from 'react';
import { clsx } from 'clsx';
import { Caption } from '@cian/ui-kit';

import * as styles from './styles.css';

const MAX_VISIBLE_COUNT = 9;

export interface IMapClusterProps {
  count: number;
  isSeen?: boolean;
  onClick(): void;
}

export const MapCluster = ({ count, isSeen, onClick }: IMapClusterProps): React.JSX.Element => (
  <button
    className={clsx(styles['cluster'], isSeen && styles['cluster--seen'])}
    data-testid="newbuildings-map-cluster"
    type="button"
    onClick={onClick}
  >
    <Caption color="text-inverted-default">{count > MAX_VISIBLE_COUNT ? `${MAX_VISIBLE_COUNT}+` : count}</Caption>
  </button>
);
